import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import SellerAdminLogin from './Login/Login';
import SellerRegistration from './Login/sellerregistration';
import SellerLandingPage from './Seller/Seller Landing Page/SellerLandingpage';

const AppWrapper = () => {
  const [loggedIn, setLoggedIn] = useState(
    !!localStorage.getItem("seller_id")
  );

  useEffect(() => {
    const handleAuthChange = () => {
      setLoggedIn(!!localStorage.getItem("seller_id"));
    };

    window.addEventListener("sellerLoggedIn", handleAuthChange);
    window.addEventListener("sellerLoggedOut", handleAuthChange);

    return () => {
      window.removeEventListener("sellerLoggedIn", handleAuthChange);
      window.removeEventListener("sellerLoggedOut", handleAuthChange);
    };
  }, []);

  return (
    <HashRouter>
      <Routes>
        {!loggedIn ? (
          <>
            <Route path="/" element={<SellerLandingPage />} />
            <Route path="/login" element={<SellerAdminLogin />} />
            <Route path="/register" element={<SellerRegistration />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            <Route path="/*" element={<App />} />
            <Route path="/login" element={<Navigate to="/admin-dashboard" replace />} />
            <Route path="/register" element={<Navigate to="/admin-dashboard" replace />} />
          </>
        )}
      </Routes>
    </HashRouter>
  );
};


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);




// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <AppWrapper />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
